<div
	*ngIf="selectedPlan$ | async as selectedPlan"
	class="h-10 flex items-center justify-center rounded-full border-2 border-bluishGray hover:border-pink mt-2 cursor-pointer"
	(click)="changePlan()"
>
	<span class="w-full max-w-40 text-pink font-effraHeavy">
		{{ selectedPlan | titlecase }} plan
	</span>
</div>
